import { useState, useEffect } from "react";
import {
  getLiveByPeriod,
  getLivePeriod,
  download,
} from "../../network/lib/ahaval.js";
import { convertToHindiNumerals, showHideLoader } from "../utils/helper.js";
import ahavalBackImg from "../../assests/images/ahaval/Ahaval.jpg";

function Ahaval() {
  const [ahavalCurrentDetails, setAhavalCurrentDetails] = useState();
  const [ahavalPeriods, setAhavalPeriods] = useState();
  const [ahavalDetails, setAhavalDetails] = useState();
  const [selectedPeriod, setSelectedPeriod] = useState("0");

  useEffect(() => {
    !ahavalCurrentDetails && populateAhavalCurrentDetails();
    !ahavalPeriods && populateAhavalPeriod();
  }, []);

  function populateAhavalCurrentDetails() {
    getLiveByPeriod(currentFinancialYear).then((res) => {
      if (res.status == 200) {
        setAhavalCurrentDetails(res.data);
      }
    });
  }

  function populateAhavalPeriod() {
    getLivePeriod().then((res) => {
      if (res.status == 200) {
        setAhavalPeriods(res.data.filter((x) => x != currentFinancialYear));
      }
    });
  }

  const handleChange = (event) => {
    setSelectedPeriod(event.target.value);
    populateAhavalDetails(event.target.value);
  };

  function populateAhavalDetails(period) {
    showHideLoader(true);

    getLiveByPeriod(period).then((res) => {
      if (res.status == 200) {
        setAhavalDetails(res.data);
        showHideLoader();
      }
    });
  }

  const handleDownload = (e) => {
    e.preventDefault();
    showHideLoader(true);

    let params = e.target.getAttribute("data-params");
    if (params) {
      download(params).then((res) => {
        if (res.status == 200 && res.data) {
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(new Blob([res.data]));
          link.download = params.split("^$$!$$^")[1];
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        showHideLoader();
      });
    }
  };

  const currentYear = new Date().getFullYear();
  const currentFinancialYear =
    convertToHindiNumerals(currentYear - 1) +
    " - " +
    convertToHindiNumerals(currentYear - 0);

  const contents = (
    <div
      style={{
        backgroundImage: `url(${ahavalBackImg})`,
        border: "3px solid #fe6902",
        borderRadius: "40px",
        height: "500px",
        backgroundRepeat: "no-repeat",
        padding: "10px 25px",
        marginTop: "18px",
      }}
    >
      {ahavalCurrentDetails && ahavalCurrentDetails.length > 0 && (
        <div className="Row">
          <div className="Cell Heading" style={{ textAlign: "left" }}>
            नविन अहवाल :
          </div>
        </div>
      )}
      {ahavalCurrentDetails && ahavalCurrentDetails.length > 0 && (
        <div className="Row">
          <div className="Cell">
            <div>
              <table cellSpacing="0" style={{ borderCollapse: "collapse" }}>
                <tbody>
                  <tr>
                    <th scope="col">&nbsp;</th>
                  </tr>
                  {ahavalCurrentDetails.map((x, i) => (
                    <tr key={i}>
                      <td>
                        <div
                          style={{
                            width: "600px",
                            border: "2px solid white",
                            borderRadius: "10px",
                          }}
                        >
                          <div>
                            <div className="ahavalCell ahavalCell-right ListBullet"></div>
                            <div
                              className="ahavalCell ahavalCell-right"
                              style={{ textAlign: "left", width: "450px" }}
                            >
                              <span>{x.fileName}</span>
                            </div>
                            <div
                              className="ahavalCell"
                              style={{ width: "100px" }}
                            >
                              <span
                                className="handle"
                                data-params={x.image}
                                onClick={handleDownload}
                              >
                                Download
                              </span>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      {ahavalPeriods && ahavalPeriods.length > 0 && (
        <div className="Row">
          <div className="Cell Heading" style={{ textAlign: "left" }}>
            जुनी अहवाल यादी :
            <select onChange={handleChange} value={selectedPeriod}>
              <option value="0">Select</option>
              {ahavalPeriods.map((x, i) => (
                <option key={i} value={x}>
                  {x}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
      {ahavalDetails && ahavalDetails.length > 0 && (
        <div className="Row">
          <div className="Cell">
            <div>
              <table cellSpacing="0" style={{ borderCollapse: "collapse" }}>
                <tbody>
                  <tr>
                    <th scope="col">&nbsp;</th>
                  </tr>
                  {ahavalDetails.map((x, i) => (
                    <tr key={i}>
                      <td>
                        <div
                          style={{
                            width: "600px",
                            border: "2px solid white",
                            borderRadius: "10px",
                          }}
                        >
                          <div>
                            <div className="ahavalCell ahavalCell-right ListBullet"></div>
                            <div
                              className="ahavalCell ahavalCell-right"
                              style={{ textAlign: "left", width: "450px" }}
                            >
                              <span>{x.fileName}</span>
                            </div>
                            <div
                              className="ahavalCell"
                              style={{ width: "100px" }}
                            >
                              <span
                                className="handle"
                                data-params={x.image}
                                onClick={handleDownload}
                              >
                                Download
                              </span>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  return contents;
}

export default Ahaval;
